module.exports = __webpack_public_path__ + "img/017-waiter.ed3b96cf.png";